<template>
  <div class="monthly-stats">
    <v-chart ref="chart" autoresize theme="light" :options="chart"/>
    <div class="monthly-stats__controls">
      <sw-button
        class="monthly-stats__control"
        v-model="parameters.rangeMode"
        :label="$t('component.chart.rangeMode')"
      ></sw-button>
      <div v-if="!parameters.rangeMode">
        <min-sel v-model="parameters.months" @input="monthsChange">
          <option :value="6">6 {{ $t('component.chart.months') }}</option>
          <option :value="12">12 {{ $t('component.chart.months') }}</option>
          <option :value="18">18 {{ $t('component.chart.months') }}</option>
          <option :value="24">24 {{ $t('component.chart.months') }}</option>
          <option :value="36">36 {{ $t('component.chart.months') }}</option>
        </min-sel>
      </div>
      <div class="monthly-stats__range" v-else>
        <in
          type="month"
          @input="rangeInput"
          class="monthly-stats__control"
          v-model="parameters.rangeStart"
          :label="$t('component.chart.rangeStart')"
        ></in>
        <in
          type="month"
          @input="rangeInput"
          class="monthly-stats__control"
          v-model="parameters.rangeStop"
          :label="$t('component.chart.rangeStop')"
        ></in>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/axios'

export default {
  data() {
    return {
      parameters: {
        months: 6,
        rangeMode: false,
        rangeStart: null,
        rangeStop: null
      },
      chart: {
        title: {
          text: this.$t('view.dashboard.monthlyStats')
        },
        textStyle: {
          fontFamily: 'lato'
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          width: '60%',
          data: [this.$t('component.chart.allUsers'), this.$t('component.chart.uniqueUsers'), this.$t('component.chart.newUsers'), this.$t('component.chart.deletedUsers'), this.$t('component.chart.sent'), this.$t('component.chart.received'), this.$t('component.chart.total')],
          selected: {}
        },
        toolbox: {
          show: true,
          feature: {
            magicType: { show: true, type: ['stack', 'tiled'], title: { stack: this.$t('component.chart.stack'), tiled: this.$t('component.chart.tiled') } },
            saveAsImage: { show: true, title: this.$t('component.chart.saveAsImage') }
          }
        },
        xAxis: {
          data: []
        },
        yAxis: [{
          type: "value",
          name: this.$t('component.chart.users')
        }, {
          type: "value",
          name: this.$t('component.chart.messages')
        }],
        series: [{
          name: this.$t('component.chart.allUsers'),
          type: 'line',
          yAxisIndex: 0,
          data: [],
          color: '#dd7373'
        },
        {
          name: this.$t('component.chart.uniqueUsers'),
          type: 'line',
          yAxisIndex: 0,
          data: [],
          color: '#007cbe'
        },
        {
          name: this.$t('component.chart.newUsers'),
          type: 'line',
          yAxisIndex: 0,
          data: [],
          color: '#ffd23f'
        }, {
          name: this.$t('component.chart.deletedUsers'),
          type: 'line',
          yAxisIndex: 0,
          data: [],
          color: '#3BCEAC'
        }, {
          name: this.$t('component.chart.sent'),
          type: 'bar',
          yAxisIndex: 1,
          stack: 'messages',
          data: [],
          color: '#4C95AA'
        }, {
          name: this.$t('component.chart.received'),
          type: 'bar',
          yAxisIndex: 1,
          stack: 'messages',
          data: [],
          color: '#4DAA57'
        }, {
          name: this.$t('component.chart.total'),
          type: 'bar',
          yAxisIndex: 1,
          data: [],
          color: '#73B5DD'
        }]
      }
    }
  },
  methods: {
    monthsDiff(d1, d2) {
      let m
      m = (d2.getFullYear() - d1.getFullYear()) * 12
      m -= d1.getMonth() + 1
      m += d2.getMonth()
      return m <= 0 ? 0 : m
    },

    loadDataToChart(monthly, messages) {
      let dates = []
      let sent = []
      let received = []
      let total = []
      let newUsers = []
      let allUsers = []
      let deletedUsers = []
      let uniqueUsers = []
      let lastPushedDate = 0

      for (let i = 0; i < monthly.length; i++) {
        let diff = this.monthsDiff(new Date(lastPushedDate), new Date(monthly[i].date))

        while (i && diff) {
          let tempDate = new Date(lastPushedDate)
          tempDate.setMonth(tempDate.getMonth() + 1)
          lastPushedDate = +new Date(tempDate)
          dates.push(this.$t(`date.months[${new Date(tempDate).getMonth()}]`))
          allUsers.push(monthly[i - 1].messenger_all_users + monthly[i - 1].webchat_all_users)
          uniqueUsers.push(0)
          newUsers.push(0)
          deletedUsers.push(0)
          diff--
        }

        dates.push(this.$t(`date.months[${new Date(monthly[i].date).getMonth()}]`))
        allUsers.push(monthly[i].messenger_all_users + monthly[i].webchat_all_users)
        uniqueUsers.push(monthly[i].messenger_unique_users + monthly[i].webchat_unique_users)
        newUsers.push(monthly[i].messenger_new_users + monthly[i].webchat_new_users)
        deletedUsers.push(monthly[i].messenger_deleted_users + monthly[i].webchat_deleted_users)
        lastPushedDate = +new Date(monthly[i].date)
      }

      const len = messages.length - 1
      let i = 0
      while (i < len) {
        if (actMonth) {
          let diff = this.monthsDiff(new Date(messages[i - 1].date), new Date(messages[i].date))
          while (diff > 0) {
            sent.push(0)
            received.push(0)
            total.push(0)
            diff--
          }
        } else {
          let diff = this.monthsDiff(new Date(monthly[i].date), new Date(messages[i].date))
          while (diff > 0) {
            sent.push(0)
            received.push(0)
            total.push(0)
            diff--
          }
        }
        let actMonth = new Date(messages[i].date).setUTCDate(1)
        actMonth = new Date(actMonth).setUTCHours(0, 0, 0, 0)
        sent.push(0)
        received.push(0)
        total.push(0)
        while (i < len && new Date(new Date(messages[i].date).setUTCDate(1)).setUTCHours(0, 0, 0, 0) === actMonth) {
          sent[sent.length - 1] += messages[i].messenger_messages_outcoming + messages[i].webchat_messages_outcoming
          received[received.length - 1] += messages[i].messenger_messages_incoming + messages[i].webchat_messages_incoming
          i++
        }
        total[total.length - 1] = sent[sent.length - 1] + received[received.length - 1]
      }

      this.chart.xAxis.data = dates
      this.chart.series[0].data = allUsers
      this.chart.series[1].data = uniqueUsers
      this.chart.series[2].data = newUsers
      this.chart.series[3].data = deletedUsers
      this.chart.series[4].data = sent
      this.chart.series[5].data = received
      this.chart.series[6].data = total
    },

    async monthsChange(v) {
      try {
        const dataReq = await axios.get(`/api/stats/monthly?months=${v}`)
        this.loadDataToChart(dataReq.data.monthlyRows, dataReq.data.messagesRows)
      } catch (e) {
        console.error(e)
      }
    },

    async rangeInput() {
      try {
        const start = this.parameters.rangeStart
        const stop = this.parameters.rangeStop
        if (!start || !stop) return
        const dataReq = await axios.get(`/api/stats/monthly-range?start=${start}&stop=${stop}`)
        this.loadDataToChart(dataReq.data.monthlyRows, dataReq.data.messagesRows)
      } catch (e) {
        console.error(e)
      }
    }
  },
  async created() {
    try {
      this.chart.legend.selected[this.$t('component.chart.total')] = false
      this.chart.legend.selected[this.$t('component.chart.newUsers')] = false
      this.chart.legend.selected[this.$t('component.chart.deletedUsers')] = false
      const rowsReq = await axios.get('/api/stats/monthly?months=6')
      this.loadDataToChart(rowsReq.data.monthlyRows, rowsReq.data.messagesRows)
    } catch (e) {
      console.error(e)
    }
  }
}
</script>

<style lang="scss" scoped>
.monthly-stats {
  @include flowElementShadow();
  background-color: white;
  margin-top: 11px;
  padding: 15px;
  border-radius: 4px;

  &__controls {
    @include alignedFlex(flex-start);
    @include standarizeStatControls();
  }

  &__control {
    margin-right: 20px;
  }

  &__range {
    @include alignedFlex(flex-start);
  }
}
</style>
